import React, { useEffect, useState } from "react";
import { config as axiosConfig } from "../shared/config";
import axios from "axios";
import style from "../shared/skeleton.module.css";

const BotDetailedStats = ({ openDetailedStat }) => {
  const [detailedStats, setDetailedStats] = useState([]);
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const botStatus = ["Live", "Initial Demand", "Retired", "On hold"];
  const [selectedStatus, setSelectedStatus] = useState(["Live"]);

  const getDetailedStats = async (selectedStatus) => {
    const config = {
      headers: {
        Authorization: `Bearer ${axiosConfig.bearerToken}`,
      },
    };

    //https://automation.unilever.com/api

    setLoading(true);
    try {
      const res = await axios.post(
        `${"https://automation.unilever.com/api"}/bot/detailed-bot-stats`,
        {
          status: selectedStatus,
        },
        config
      );

      console.log("res.data", res.data);

      if (res.data.status === "success") {
        setDetailedStats(res.data.data.technologyBots);
        setCount(res.data.data.totalCount);
      }
      setLoading(false);
    } catch (error) {
      console.log("Error:", error);
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, checked } = e.target;
    console.log(name, checked, typeof checked);
    if (checked) {
      setSelectedStatus([...selectedStatus, name]);
    } else {
      setSelectedStatus(selectedStatus.filter((status) => status !== name));
    }
  };

  useEffect(() => {
    getDetailedStats(selectedStatus);
  }, [selectedStatus]);

  return (
    <div
      className={`${
        openDetailedStat ? "w-[90%]" : "w-0"
      } transition-all absolute left-[50%] top-12 bg-[#f7f7f7] min-h-[100px] max-h-[70vh] shadow-md z-20 translate-x-[-50%] p-2 flex flex-col gap-3`}
    >
      <div className="bg-[#176bf9] flex items-center justify-center gap-10 py-1 text-white text-lg">
        <span>Detailed Bot Stats</span>{" "}
        <span className="text-sm">Total Bot Count: {count}</span>
      </div>
      <div className="!border !border-[#176bf9] p-1 text-xs text-center">
        Calculated by catering New Request & Roll Out
      </div>
      <div className="flex items-center gap-5">
        Select Bot Status:
        <div className="flex items-center justify-between w-[50%]">
          {botStatus.map((status, id) => (
            <div key={id} className="flex items-center gap-1">
              <input
                type="checkbox"
                name={status}
                onChange={handleFilterChange}
                checked={selectedStatus.includes(status)}
                className="cursor-pointer"
              />
              <label className="mb-[2px]">{status}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 overflow-y-scroll">
        {loading ? (
          <>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item, index) => (
              <div
                key={index}
                className={`${style.skeleton_box} aspect-square`}
              ></div>
            ))}
          </>
        ) : (
          detailedStats.map((bot, idx) => (
            <div
              key={idx}
              className="bg-[#ecf3ff] !aspect-square !border-[#1e52ac31] !border-[1px] shadow-sm flex flex-col justify-center items-center gap-2"
            >
              <div className="font-unilever-shilling-medium text-lg">
                {bot?.count}
              </div>
              <div className="font-unilever-shilling-normal text-sm text-center px-1">
                {bot?.technology}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BotDetailedStats;

